import { useMemo } from "react";
import { useCameraDevice } from "../../../hooks/useCameraDevice";

/**
 * QRCodeScan-specific webcam hook.
 * Wraps the shared `useCameraDevice` hook and adds pre-built videoConstraints
 * (torch is already included in the shared hook).
 */
export const useWebcam = () => {
    const camera = useCameraDevice();

    const videoConstraints = useMemo(
        () => ({
            facingMode: "environment",
            width: 960,
            height: 720,
            torch: camera.torchEnabled,
            ...(camera.selectedDeviceIdExists && camera.selectedDeviceId
                ? { deviceId: { exact: camera.selectedDeviceId } }
                : { zoom: 1.0 }),
        }),
        [camera.selectedDeviceId, camera.selectedDeviceIdExists, camera.torchEnabled]
    );

    return {
        ...camera,
        videoConstraints,
    };
};

